<template>
<div class="info">
	<div class="title">保障计划及人员
		<a class="title-a" v-if="from=='policy'&&(info.statusCode==2||info.statusCode==3)" @click="toEdit">参加人员编辑</a>
		<!-- <a 
			:href="`/pc/cxw/exportInsurancePersonnels?id=${info.id}`" 
			target="_blank" 
			v-if="from=='policy'"
			class="title-a"
		>下载参加人员信息</a> -->
	</div>
	
	<Form :label-width="120" ref="form" class="mt15">
		<template  v-if="from!='policy'">
			<FormItem label="保障期限：" class="w600">{{info.insuredPeriodName}}</FormItem>
			<FormItem label="保障起期：" class="w600">{{info.effectiveDateStart}}</FormItem>
			<FormItem label="保障止期：" class="w600">{{info.effectiveDateEnd}}</FormItem>
		</template>
		<FormItem label="附加险：" class="w600" v-if="info.subjoinAllDay||info.subjoinOwnMedicine||info.subjoinProportionAdj">
			<p v-if="info.subjoinAllDay">附加24小时意外 基础方案价格*110%</p>
			<p v-if="info.subjoinOwnMedicine">附加自费药补偿 基础方案价格*115%</p>
			<p v-if="info.subjoinProportionAdj">附加伤残赔偿比例调整  基础方案价格*110%</p>
		</FormItem>
	</Form>
	<div class="recognize-table mt10 pb20">
		<Table :columns="columns" border highlight-row :data="list">
			<template slot-scope="{ row, index }" slot="insurantCertificateNumber">
				{{from=='order'?hideIdCard(row.insurantCertificateNumber):row.insurantCertificateNumber}}
			</template>
			<template slot-scope="{ row, index }" slot="insurantGender">
				{{row.insurantGender==1?'男':'女'}}
			</template>
			<template slot-scope="{ row, index }" slot="insurantAmount">
				{{row.insurantAmount||'-'}}
			</template>
		</Table>
	</div>
	<Form :label-width="120" ref="form" v-if="from!='confirm'">
		<FormItem 
			label="投保单：" 
			class="w600">
			<div style="display:flex;flex-wrap:wrap;">
				<ImageShow 
					v-for="(img,i) in info.insurancePolicyUrl"
					:url="img"
					:key="i" />
			</div>
		</FormItem>
        <FormItem 
            label="批改单（盖章）：" :label-width="140" v-if="info.correctUrl||(info.correctUrls&&info.correctUrls.length>0)">
            <div style="display:flex;flex-wrap:wrap;" v-if="from=='policy'">
                <div v-for="(item,i) in info.correctUrls" :key="i" class="correctUrlItem">
                    <img :src="item.correctUrl" height="140"/>
                    <p>
						<a :href="item.correctUrl" target="_blank">查看大图</a>
						{{item.createTime}}
					</p>
                </div>
            </div>
            <div style="display:flex" v-if="from=='order'">
                <ImageShow :url="info.correctUrl"/>
            </div>
        </FormItem>
	</Form>
</div>
</template>
<script>
import ImageShow from '../common/Image'
export default {
	components:{ImageShow},
	props:{
		info:Object,
		from:{
			type:String,
			default:'confirm'// confirm/order/policy
		},
	},
	data () {
		return {
			columns:[
				{title: '序号',type: 'index',width:70,align:'center'},
				{title: '工种',key: 'jobTypeName',width:150},
				{title: '保障方案',key: 'insuranceSchemeName',minWidth:280},
				{title: '姓名',key: 'insurantName',width:120},
				{title: '身份证号',slot: 'insurantCertificateNumber',width:190},
				{title: '性别',slot: 'insurantGender',width:70},
				{title: '年龄',key: 'insurantAge',width:70},
			],
			list:[],
		}
	},
	computed:{
	   days(){
			if(this.info.effectiveDateStart&&this.info.effectiveDateEnd){
				return this.getDays(this.formatDate(this.info.effectiveDateStart),this.formatDate(this.info.effectiveDateEnd));
			}else {
				return ""
			}
		},
	},
	watch:{
		info (v) {
			if(v.list&&v.list.length>0){
				this.list=v.list
			}
		}
	},
	created(){
		if(this.from=='confirm'){
			// 从确认支付页面来的
			let list=[
				{title: '保障起期',key: 'effectiveDateStart',width:180},
				{title: '保障止期',key: 'effectiveDateEnd',width:180},
				{title: '保费(元)',slot: 'insurantAmount',width:110}
			]
			this.columns=this.columns.concat(list)
		}else{
			// 从订单保单来的
			let list=[
				{title: '保障状态',key: 'insuranceStatusName',width:100},
				{title: '保障起期',key: 'effectiveDateStart',width:180},
				{title: '保障止期',key: 'effectiveDateEnd',width:180},
			]
			// if(this.from=='order'){
			//     list.push({title: '保费',key: 'effectiveAmountYuan',width:110})
			//     list.push({title: '应付费用',key: 'insurantAmount',width:100})
			// }else{
				list.push({title: '保费(元)',slot: 'insurantAmount',width:110})
			// }
			list.push({title: '备注',key: 'remarks',width:120})
			this.columns=this.columns.concat(list)
		}
		
		if(this.info.list&&this.info.list.length>0){
			this.list=this.info.list
		}
	},
	methods: {
		hideIdCard (str,frontLen=4,endLen=3) { 
			var len = str.length-frontLen-endLen;
			var star = '';
			for (var i=0;i<len;i++) {
				star+='*';
			}
			return str.substring(0,frontLen)+star+str.substring(str.length-endLen);
		},
		toEdit () {
			this.checkOrderRefuseStatus({
				policyId:this.info.id,
				bizCode:'KAS_GZ_GYS'
			}).then(()=>{
				this.$axios.post('/employerLiability/checkUnPaidOrder.json',{
					id:this.info.id
				}).then(res=>{
					if(res){
						this.$router.push(`/company-group-employer/edit/${this.info.id}`)
					}
				});
			})
		}
	},
}
</script>
<style scoped lang="less">
	.title-a{
		font-size: 14px;
		margin-left: 15px;
	}
	.pb20{
		padding-bottom: 20px;
	}
    .correctUrlItem{
        margin-right: 20px;
        text-align: center;
		a{
			font-size: 12px;
			display: block;
		}
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployer/RecognizeInfo.vue